/**
 * Crowdin bold markup uses <0>...</0> in exports; sometimes it is not converted to <strong>.
 * Fallback for rules HTML before rendering in GameRulesOverlay.
 */
export function sanitizeCrowdinRulesHtml(html) {
  if (!html || typeof html !== "string") return html;

  if (!html.includes("<0>") && !html.includes("</0>")) {
    return html;
  }

  return html.replace(/<0>/g, "<strong>").replace(/<\/0>/g, "</strong>");
}
